module.exports = __webpack_public_path__ + "img/Gefahrstoffzug_ABC_Zug.56aaddba.svg";